module.exports = __webpack_public_path__ + "img/front3.dff79fb2.png";